import type { Dictionary } from "./en";

export const ar: Partial<Dictionary> = {
  "lang.select": "اللغة",
  "lang.change": "تغيير اللغة",

  "nav.hot": "الأكثر رواجًا",
  "nav.categories": "الفئات",
  "nav.marketplace": "السوق",
  "nav.fund": "التمويل",
  "nav.promote": "الترويج",
  "nav.earn": "الأرباح",
  "nav.referrals": "الإحالات",
  "nav.soon": "قريبًا",
  "nav.login": "تسجيل الدخول",
  "nav.dashboard": "لوحة التحكم",
  "nav.getHot": "اشتعل الآن",
  "nav.menu": "القائمة",
  "nav.walletBalance": "رصيد Heat",
  "nav.home": "الصفحة الرئيسية لـ BeHot.Now",
  "nav.profile": "لوحة التحكم",
  "nav.messages": "الرسائل",
  "nav.logout": "تسجيل الخروج",
  "nav.balance": "الرصيد",

  "footer.tagline": "مكان واحد للاكتشاف والتوظيف والبيع والترويج. ادخل اللوحة. كن الأكثر رواجًا. كن مرئيًا.",
  "footer.howItWorks": "كيف يعمل",
  "footer.operatedBy": "تُدار بواسطة",
  "footer.disclosure": "المواضع المدفوعة موضّحة بوضوح كمدفوعة. الأسعار معروضة بالدولار الأمريكي.",
  "footer.platform": "المنصة",
  "footer.comingSoon": "قريبًا",
  "footer.legal": "الشؤون القانونية",
  "footer.hotNow": "الرائج الآن",
  "footer.hotHistory": "سجل HOT",
  "footer.getHot": "اشتعل الآن",
  "footer.referrals": "الإحالات",
  "footer.withdrawal": "حق الانسحاب",
  "footer.terms": "شروط الخدمة",
  "footer.privacy": "سياسة الخصوصية",
  "footer.cookie": "سياسة ملفات تعريف الارتباط",
  "footer.rights": "جميع الحقوق محفوظة.",
  "footer.compareLeaderboards": "قارن مع لوحات المتصدرين الأخرى",

  "home.h1.q": "ما هو",
  "home.h1.a1": "إنه المكان الذي يمكن فيه لـ",
  "home.h1.anything": "أي شيء",
  "home.h1.a2": "أن ينافس على الانتباه!",
  "home.sub1": "هل أنت مؤثر أو شخصية عامة أو نجم؟",
  "home.sub2":
    "أو لديك أغنية أو حفلة أو ملف شخصي أو علامة تجارية أو شركة ناشئة أو تطبيق أو منتج أو نشاط تجاري أو فعالية أو حتى مجرد فكرة؟",
  "home.getItOnCharts": "ضعه في القوائم",
  "home.now": "الآن",
  "home.moreBoosts": "تعزيزات أكثر.",
  "home.higherRanking": "ترتيب أعلى.",
  "home.morePeople": "مشاهدون أكثر.",
  "home.more": "المزيد",
  "home.browseChart": "تصفح قائمة {label}",
  "home.listIt": "أضِفه",
  "home.boostIt": "عزّزه",
  "home.climb": "ارتقِ",
  "home.getSeen": "كن مرئيًا",
  "home.howItWorks": "كيف يعمل",
  "home.generalBoard": "القائمة العامة",
  "home.podium.title": "أفضل 3 في كل لوحة",
  "home.podium.sub": "منصة التتويج الحالية لكل لوحة فئة.",
  "home.generalBoardSub": "أفضل الإدراجات من كل الفئات، مرتبة حسب إجمالي الـ Heat النشط.",
  "home.allBoards": "كل القوائم",
  "home.loadingBoard": "جارٍ تحميل القائمة العامة…",

  "lowHeat.title": "رصيد الـ Heat يوشك على النفاد",
  "lowHeat.body":
    "رصيد الـ Heat يوشك على النفاد — ادعُ أصدقاءك لكسب المزيد، أو اشحن محفظتك الآن.",
  "lowHeat.invite": "دعوة الأصدقاء",
  "lowHeat.topUp": "شحن المحفظة",
  "lowHeat.later": "لاحقًا",

  "cookie.title": "نحن نستخدم ملفات تعريف الارتباط",
  "cookie.accept": "قبول الكل",
  "cookie.reject": "رفض غير الضروري",
  "cookie.settings": "إعدادات ملفات تعريف الارتباط",
  "cookie.save": "حفظ الاختيارات",

  "common.close": "إغلاق",
  "common.loading": "جارٍ التحميل…",
  "hiw.h1": "كيف يعمل BeHot.Now",
  "hiw.toc": "في هذه الصفحة",
  "hiw.toc.title": "المحتويات",
  "hiw.toc.steps": "الخطوات الخمس",
  "hiw.toc.rules": "قواعد الترتيب",
  "hiw.toc.entry": "كيف يُحتسب سعر الدخول",
  "hiw.toc.glossary": "المصطلحات",
  "hiw.toc.pricing": "الأسعار",
  "hiw.toc.faq": "الأسئلة الشائعة",
  "hiw.toc.roadmap": "ما القادم",
  "hiw.toc.services": "كل الخدمات",
  "hiw.toc.contact": "تواصل معنا",
  "hiw.steps.title": "الخطوات الخمس",
  "hiw.ready.title": "جاهز للمنافسة؟",
  "hiw.ready.body": "أضف مشروعك أو اكتشف ما هو رائج الآن.",
  "hiw.ready.list": "أضف إدراجك الآن",
  "hiw.ready.browse": "تصفح القوائم",
  "hiw.rules.title": "قواعد الترتيب",
  "hiw.entry.title": "كيف يُحتسب سعر الدخول إلى القائمة",
  "hiw.entry.intro": "الدخول إلى القائمة بسيط، لكن السعر متغيّر. تدفع دائمًا أقل Heat نشط في القائمة مضافًا إليه مقدار الزيادة الخاص بها. يوضح هذا المثال آلية الحساب.",
  "hiw.entry.lowest": "أقل Heat نشط حاليًا في القائمة",
  "hiw.entry.plus": "+ الزيادة",
  "hiw.entry.increment": "زيادة القائمة",
  "hiw.entry.min": "الحد الأدنى لتكلفة دخولك",
  "hiw.entry.note": "إذا كانت القائمة فارغة أو أُعيد ضبطها للتو، فتكلفة الدخول هي عرض الافتتاح — عادةً 3 Heat — لينضم الأوائل بسعر منخفض قبل احتدام المنافسة.",
  "hiw.heat": "{n} Heat",
  "hiw.glossary.title": "المصطلحات",
  "hiw.pricing.title": "الأسعار",
  "hiw.pricing.oneHeat": "سعر 1 Heat",
  "hiw.pricing.oneHeatNote": "دفعة واحدة · بدون اشتراك",
  "hiw.pricing.listing": "سعر الإدراج",
  "hiw.pricing.listingNote": "لإضافة مشروعك إلى قائمة",
  "hiw.pricing.entry": "الدخول إلى القائمة",
  "hiw.pricing.entryValue": "أقل Heat + الزيادة",
  "hiw.pricing.entryNote": "مثال: 12 Heat + 1 = 13 Heat للدخول",
  "hiw.pricing.opening": "عرض الافتتاح",
  "hiw.pricing.openingNote": "تكلفة الدخول في قائمة جديدة أو فارغة",
  "hiw.faq.title": "الأسئلة الشائعة",
  "hiw.roadmap.title": "ما القادم",
  "hiw.soon": "قريبًا",
  "hiw.promote.body": "اشترِ إجراءات ترويجية حقيقية من صنّاع المحتوى: منشورات وقصص وإشادات وتعاونات، بأسعار ثابتة مع ضمان دفع وإثبات تنفيذ.",
  "hiw.promote.more": "اعرف المزيد عن Promote",
  "hiw.earn.body": "ينشر صنّاع المحتوى قائمة أسعارهم، ويتلقّون الطلبات مباشرة، ويسلّمون مع إثبات، ثم يسحبون أرباحهم بالدولار الأمريكي.",
  "hiw.earn.more": "اعرف المزيد عن Earn",
  "hiw.services.title": "كل الخدمات بالتفصيل",
  "hiw.services.intro": "BeHot.Now أكثر من مجرد قائمة. إليك كل ما تقدّمه المنصة اليوم وكل ما هو قادم.",
  "hiw.services.open": "افتح {name}",
  "hiw.contact.title": "تحدّث إلينا",
  "hiw.contact.intro": "اختر الخدمة التي يتعلق بها استفسارك — بما في ذلك الدعم والمبيعات — وسنوجّهه إلى الفريق المناسب.",
  "hiw.cta.title": "جاهز للمركز 01؟",
  "hiw.cta.button": "ادخل إلى قائمة",
  "stats.liveUsers": "{n} مستخدم مباشر",
  "stats.totalVisits": "{n} زيارة إجمالاً",
};
